import { render, staticRenderFns } from "./EventFormDialog.vue?vue&type=template&id=8409d374&scoped=true"
import script from "./EventFormDialog.vue?vue&type=script&lang=ts"
export * from "./EventFormDialog.vue?vue&type=script&lang=ts"
import style0 from "./EventFormDialog.vue?vue&type=style&index=0&id=8409d374&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8409d374",
  null
  
)

export default component.exports